// extracted by mini-css-extract-plugin
export default {"settingsContainer":"AssetOwnerSettings_settingsContainer__0Cycr"};